export default __webpack_public_path__ + "static/media/Digital Keys.f3ed6b58.svg";